import React from "react";
import { addLevelToRoutes } from "../utils/guradHelper";
// ====================
// Import Page Components
// ====================

// --- Level 2 Components ---
import LevelTwoUserVerificationsList from "../../../pages/LevelTwo/LevelTwoUserVerificationList";
import LevelTwoUserVerification from "../../../pages/LevelTwo/LevelTwoUserVerification";
import LevelTwoDashboard from "../../../pages/LevelTwo/LevelTwoDashboard";
import { LevelTwoApplications } from "../../../pages/LevelTwo/LevelTwoApplicationApproval";
import { ViewApplicationForLevel2 } from "../../../pages/LevelTwo/LevelTwoApplicationDetails";
import { LevelTwoApplicationViewDocsAndConfirm } from "../../../pages/LevelTwo/LevelTwoApplicationViewDocsAndConfirm";
import { LevelTwoPaymentApproval } from "../../../pages/LevelTwo/LevelTwoPaymentConfirm";

// --- Level 1 Components ---
import { LevelOneApplications } from "../../../pages/LevelOneReview/LevelOneApplicationApproval";
import { ViewApplicationForLevel1 } from "../../../pages/LevelOneReview/LevelOneApplicationDetails";
import { LevelOneApplicationViewDocsAndConfirm } from "../../../pages/LevelOneReview/LevelOneApplicationViewDocsAndConfirm";
import LevelOneDashboard from "../../../pages/LevelOneReview/LevelOneDashboard";

// --- Level 3 Components ---
import LevelThreeApplicationDoc from "../../../pages/LevelThree/LevelThreeapplicationDoc";
import LevelThreeReviewRemark from "../../../pages/LevelThree/LevelThreeReviewRemark/LevelThreeReviewRemark";
import LevelThreeDemandNoteFeild from "../../../pages/LevelThree/LevelThreeDemandNoteFeild/LevelThreeDemandNoteFeild";
import { LevelThreePaymentApproval } from "../../../pages/LevelThree/LevelThreePaymentApproval";
import LevelThreeDashboard from "../../../pages/LevelThree/LevelThreeDashbard";
import LevelThreeApplications from "../../../pages/LevelThree/LevelThreeApplications";
import UserApprovalDetails from "../../../pages/LevelThree/userApprovalDetails";
import LevelThreeApplicationDetail from "../../../pages/LevelThree/levelThreeApplicationDetail";

// --- User Components ---
import { UserDashboard } from "../../../pages/UserDashboard/UserDashboard";
import { UserProfile } from "../../../pages/UserProfile/UserProfile";
import { ViewApplication } from "../../ViewApplication/ViewApplication";
import ResubmitApplication from "../../../pages/ResubmitApplication/ResubmitApplication";
import { ViewApplicationDetailsAdmin } from "../../ViewApplication/ViewApplication.admin";
import { Applications } from "../../../pages/Applications/Applications";

// --- Admin / Super Admin Components ---
import AddUser from "../../../pages/addUser/addUser";
import Dashboard from "../../../pages/superAdmin/dashboard/dashboard";
import AppFields from "../../../pages/superAdmin/appFields/appFields";
import FormConfigurations from "../../../pages/superAdmin/FormConfigurations/FormConfigurations";
import { AddFormConfig } from "../../FormConfigurations/AddForm";
import { EditFormConfig } from "../../FormConfigurations/EditForm";
import StepConfigurations from "../../../pages/superAdmin/StepConfigurations/StepConfigurations";
import { AddStepConfig } from "../../../pages/superAdmin/StepConfigurations/AddStepConfigurations";
import { EditStepConfigurations } from "../../../pages/superAdmin/StepConfigurations/EditStepConfigurations";
import Logo from "../../../pages/superAdmin/logo/logo";
import FooterPage from "../../../pages/superAdmin/footerPage/footerPage";
import DemandNote from "../../../pages/superAdmin/demandNote/demandNote";
import Certificate from "../../../pages/certificatePage/certificatePage";
import EditUser from "../../../pages/editUser/editUser";
import DocumentConfig from "../../../pages/documentConfig/documentConfig";
import Declaration from "../../../pages/documentConfig/declarationPage";
import NewDocument from "../../../pages/documentConfig/newDocument";
import SystemIdGenerator from "../../../pages/superAdmin/systemIdgenerator/systemIdgenerator";
import RegistrationFields from "../../../pages/superAdmin/registrationFields/registrationFields";
import RolePrivilege from "../../../pages/superAdmin/rolePrivilege/rolePrivilege";
import Ticker from "../../../pages/superAdmin/ticker/ticker";
import AutoFillFieldsData from "../../../pages/superAdmin/AutoFillFieldsData/AutoFillFieldsData";
import TemplateConfig from "../../../pages/superAdmin/TemplateConfig/templateConfig";
import LaunchPage from "../../../pages/launchPage/launchPage";
import CertificateConditions from "../../../pages/superAdmin/certificateCondition/certificateCondition";
import CreateCertificateConditions from "../../../pages/superAdmin/certificateCondition/createCertificateCondition";
import SystemSettings from "../../../pages/superAdmin/systemSetting/systemSetting";
import BankDetails from "../../../pages/superAdmin/bankDetails/bankDetails";
import Banner from "../../../pages/banner/banner";
import UserAccountNotVerified from "../../../pages/superAdmin/userAccountNotVerified/userAccountNotVerified";
import AccountVerificationStatus from "../../../pages/superAdmin/accountVerificationStatus/accountVerificationStatus";
import PlotDetails from "../../../pages/superAdmin/plotShape/plotDetails";
import PlotShape from "../../../pages/superAdmin/plotShape/plotShape";
import EditRolePrivilege from "../../../pages/superAdmin/editRolePrivilege/editRolePrivilege";
import GridRolePrivilege from "../../../pages/superAdmin/gridRolePrivilege/gridRolePrivilege";
// --- Payment Components ---
import PayNow from "../../../pages/userPayment/payNow/payNow";
import PaymentList from "../../../pages/userPayment/paymentList/paymentList";
import ViewUserPayment from "../../../pages/userPayment/viewUserPayment/viewUserPayment";

// --- Other Application Components ---
import { AddApplication } from "../../../pages/AddApplication/AddApplication";
import { EditApplication } from "../../../pages/EditApplication/EditApplication";
import NewDeclaration from "../../../pages/documentConfig/createDeclaration";
import CreateDemandNote from "../../../pages/superAdmin/demandNote/createDemandNote";
import UserApprovals from "../../../pages/LevelThree/userApprovals";
import NewUser from "../../../pages/newUser/newUser";
import CustomErrorPage from "../../../pages/CustomErrorPage/customErrorPage";

// ====================
// Categorized Level Routes (Separated by Level)
// ====================

// Level 1 Routes (4)
const level1Routes: {
  path: string;
  level?: string[];
  Component: any;
  useWrapper?: boolean;
}[] = [
  { path: "/level-1-applications", Component: LevelOneApplications },
  {
    path: "/level-1-application-details",
    Component: ViewApplicationForLevel1,
  },
  {
    path: "/level-1-verify-application",
    Component: LevelOneApplicationViewDocsAndConfirm,
  },
  { path: "/level-1-dashboard", Component: LevelOneDashboard },

  // {
  //   path: "/view-application-details",
  //   Component: ViewApplicationDetailsAdmin,
    
  // },
];

// Level 2 Routes (7)
const level2Routes: {
  path: string;
  level?: string[];
  Component: React.ComponentType<any>;
  useWrapper?: boolean;
}[] = [
  {
    path: "/level-2-user-verification",
    Component: LevelTwoUserVerification,
  },
  {
    path: "/level-2-user-verifications-list",
    Component: LevelTwoUserVerificationsList,
  },
  { path: "/level-2-dashboard", Component: LevelTwoDashboard },
  { path: "/level-2-applications", Component: LevelTwoApplications },
  {
    path: "/level-2-application-details",
    Component: ViewApplicationForLevel2,
  },
  { path: "level-2-payment-details", Component: LevelTwoPaymentApproval },
  // {
  //   path: "/view-application-details",
  //   Component: ViewApplicationDetailsAdmin,
  // },

  {
    path: "/level-2-verify-application",
    Component: LevelTwoApplicationViewDocsAndConfirm,
  },
];

// Level 3 Routes (8)
const level3Routes: {
  path: string;
  level?: string[];
  Component: any;
  useWrapper?: boolean;
}[] = [
  {
    path: "/level-three-application-doc",
    Component: LevelThreeApplicationDoc,
  },
  { path: "/user-approvals", Component: UserApprovals },
  { path: "/level-three-review-remark", Component: LevelThreeReviewRemark },
  {
    path: "/level-three-demand-note-feild",
    Component: LevelThreeDemandNoteFeild,
  },
  {
    path: "/level-3-payment-details",
    Component: LevelThreePaymentApproval,
  },
  { path: "/level-three-dashboard", Component: LevelThreeDashboard },
  { path: "/level-three-applications", Component: LevelThreeApplications },
  {
    path: "/level-three-user-approval-details",
    Component: UserApprovalDetails,
  },
  // {
  //   path: "/view-application-details",
  //   Component: ViewApplicationDetailsAdmin,
  // },

  {
    path: "/level-three-application-detail",
    Component: LevelThreeApplicationDetail,
  },
];

// ====================
// Other Categorized Routes
// ====================

// User Routes (6)
const userRoutes: {
  path: string;
  level?: string[];
  Component: React.ComponentType<any>;
  useWrapper?: boolean;
}[] = [
  { path: "/user-dashboard", Component: UserDashboard },
  { path: "/payment-list", Component: PaymentList },
  { path: "/pay-now", Component: PayNow },
  { path: "/view-user-payment", Component: ViewUserPayment },
  { path: "/add-new-application", Component: AddApplication },
  
  { path: "/user-applications", Component: Applications },
  { path: "/view-application", Component: ViewApplication },
  { path: "/resubmit-application", Component: ResubmitApplication },
  { path: "/user-account-not-verified", Component: UserAccountNotVerified },
  {
    path: "/account-verification-status",
    Component: AccountVerificationStatus,
  },

  { path: "/edit-application", Component: EditApplication },
];

// Admin / Super Admin Routes
const adminRoutes: {
  path: string;
  level?: string[];
  Component: React.ComponentType<any>;
  useWrapper?: boolean;
}[] = [
  { path: "/dashboard", Component: Dashboard },
  { path: "/add-user", Component: AddUser },
  { path: "/new-user", Component: NewUser },
  { path: "/application-fields", Component: AppFields },
  { path: "/form-configurations", Component: FormConfigurations },
  { path: "/step-configurations", Component: StepConfigurations },
  { path: "/add-form-configuration", Component: AddFormConfig },
  { path: "/add-step-configuration", Component: AddStepConfig },
  { path: "/edit-form-configuration/:id", Component: EditFormConfig },

  {
    path: "/edit-step-configuration/:id",
    Component: EditStepConfigurations,
  },
  { path: "/logo", Component: Logo },
  { path: "/footer-page", Component: FooterPage },
  { path: "/demand-note", Component: DemandNote },
  { path: "/certificate", Component: Certificate },
  { path: "/edit-user", Component: EditUser },
  { path: "/document-config", Component: DocumentConfig },
  { path: "/declaration-page", Component: Declaration },
  { path: "/system-id-generator", Component: SystemIdGenerator },
  { path: "/registration-fields", Component: RegistrationFields },
  { path: "/role-privilege", Component: RolePrivilege },
  { path: "/ticker", Component: Ticker },
  { path: "/new-document", Component: NewDocument },
  { path: "/edit-role-privilege", Component: EditRolePrivilege },
  { path: "/grid-role-privilege", Component: GridRolePrivilege },
  { path: "/auto-fill-fields", Component: AutoFillFieldsData },
  { path: "/template-config", Component: TemplateConfig },

  { path: "/certificate-condition", Component: CertificateConditions },
  {
    path: "/new-certificate-condition",
    Component: CreateCertificateConditions,
  },
  { path: "/system-settings", Component: SystemSettings },
  { path: "/bank-details", Component: BankDetails },
  { path: "/banner", Component: Banner },
  { path: "/new-declaration", Component: NewDeclaration },
  { path: "/create-demand-note", Component: CreateDemandNote },
  { path: "/plot-shape", Component: PlotShape },
  { path: "/plot-details", Component: PlotDetails },

  // {
  //   path: "/view-application-details",
  //   Component: ViewApplicationDetailsAdmin,
  // },
];

// Fallback Route (1, rendered without layout wrapper)
const fallbackRoute: {
  path: string;
  level?: string[];
  Component: React.ComponentType<any>;
  useWrapper?: boolean;
}[] = [
  { path: "*", Component: CustomErrorPage, useWrapper: false },
  { path: "/launch-page", Component: LaunchPage },
  {
      path: "/view-application-details",
      Component: ViewApplicationDetailsAdmin,
    },
    { path: "/user-profile", Component: UserProfile },
];

// ====================
// Merge All Routes into One Master Array
// ====================
// Apply levels dynamically
const routesConfig = [
  ...addLevelToRoutes(["level 1"], level1Routes),
  ...addLevelToRoutes(["level 2"], level2Routes),
  ...addLevelToRoutes(["level 3", "system admin"], level3Routes),
  ...addLevelToRoutes(["user"], userRoutes),
  ...addLevelToRoutes(["system admin"], adminRoutes),
  ...fallbackRoute,
];

export { routesConfig };
